/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';

//add plugin
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'; //IMPORT NEW PLUGIN
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert'; //IMPORT NEW PLUGIN
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize'; //IMPORT NEW PLUGIN
import Font from '@ckeditor/ckeditor5-font/src/font'; //IMPORT NEW PLUGIN
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily';
import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters';
import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials';
// import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';

export default class ClassicEditor extends ClassicEditorBase { }

// Plugins to include in the build.
ClassicEditor.builtinPlugins = [
    Essentials,
    Autoformat,
    Bold,
    Italic,
    Underline,
    BlockQuote,
    Strikethrough,
    Superscript,
    Subscript,
    Heading,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    LinkImage,
    Indent,
    Link,
    List,
    TodoList,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
    TextTransformation,
    Alignment, //ADD PLUGIN
    ImageInsert, //ADD PLUGIN
    ImageResize, //ADD PLUGIN
    Font, //ADD PLUGIN
    FontFamily,
    SpecialCharacters,
    SpecialCharactersEssentials
    // SourceEditing
];

// Editor configuration.
ClassicEditor.defaultConfig = {
    toolbar: {
        items: [
            // "sourceEditing",
            'heading',
            '|',
            'fontfamily',
            'fontsize',
            '|',
            'fontColor', //DISPLAY HERE
            'fontBackgroundColor', //DISPLAY HERE
            '|',
            'bold',
            'italic',
            'strikethrough',
            'underline',
            'subscript',
            'superscript',
            '|',
            'alignment:left',
            'alignment:right',
            'alignment:center',
            'alignment:justify',
            '-',
            'bulletedList',
            'numberedList',
            'todoList',
            '|',
            'link',
            'insertTable',
            '|',
            'outdent',
            'indent',
            '|',
            'insertImage', //DISPLAY HERE
            'mediaEmbed', //not use
            'blockQuote',
            'specialCharacters',
            '|',
            'undo',
            'redo'
        ],
        shouldNotGroupWhenFull: true
    },
    image: {
        styles: ['alignLeft', 'alignCenter', 'alignRight'],
        resizeOptions: [
            {
                name: 'resizeImage:original',
                label: 'Original',
                value: null
            },
            {
                name: 'resizeImage:50',
                label: '50%',
                value: '50'
            },
            {
                name: 'resizeImage:75',
                label: '75%',
                value: '75'
            }
        ],
        toolbar: [
            'linkImage',
            'imageStyle:alignLeft',
            'imageStyle:alignCenter',
            'imageStyle:alignRight',
            '|',
            'resizeImage',
            '|',
            'imageTextAlternative'
        ]
    },
    mediaEmbed: {
        previewsInData: true,
        providers: [
            {
                name: 'youtube',
                // Regex để nhận diện URL YouTube
                url: [
                    /^youtube\.com\/.+/,
                    /^youtu\.be\/.+/,
                    /^www\.youtube\.com\/.+/
                ],
                html: (match) => {
                    const url = match.input.replace("watch?v=", "embed/");
                    return `<div class="content"><iframe width="100%" src="https://www.${url}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
                }
            },
            {
                name: 'mp4',
                // Regex để nhận diện link MP4
                url: /\.mp4$/,
                html: (match) => {
                    return `<div class="content"><video controls width="100%" src="${match.input}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></video></div>`;
                }
            }
            // Thêm các nhà cung cấp khác nếu cần
        ]
    },
    table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    fontSize: {
        options: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30]
    },
    fontFamily: {
        options: [
            'default',
            'Arial, Helvetica, sans-serif',
            'Courier New, Courier, monospace',
            'Georgia, serif',
            'Lucida Sans Unicode, Lucida Grande, sans-serif',
            'Tahoma, Geneva, sans-serif',
            'Times New Roman, Times, serif',
            'Trebuchet MS, Helvetica, sans-serif',
            'Verdana, Geneva, sans-serif'
        ]
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    extraAllowedContent: '*(*);*{*}',
    allowedContent: true,
    language: 'en'
};
